/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { AlertModalWrapper } from '../AlertModalWrapper.ts';

export const IndexTablePopup = styled(AlertModalWrapper)`
  padding-top: 26px;
  padding-bottom: 36px;
  box-shadow: ${({ theme }) => theme.customShadows.medium};
`;
